<template>
  <div width="50%" style="margin-left: 20%;margin-right: 20%;margin-top: 10%;">

    <!-- 编辑界面 -->
    <el-form label-width="200px" :model="editForm.rightTotal" :rules="rules" ref="editForm">
      <el-form-item label="总计" prop="rightTotal">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.rightTotal"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="编号" prop="orderIdName">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.orderIdName"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="登录页邮箱" prop="loginEmail">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.loginEmail"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="数量" prop="numberName">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.numberName"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="扣库按钮" prop="reduceButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.reduceButton"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="显示扣库存总计：" prop="reduceButtonDesc">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.reduceButtonDesc"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="复制订单" prop="copyButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.copyButton"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="清除按钮" prop="clearButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.clearButton"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="存储订单" prop="saveButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.saveButton"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="扣存储键" prop="reduceCacheButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.reduceCacheButton"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="订单总计：" prop="reduceTotal">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.reduceTotal"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="请输入库存" prop="reducePlaceHolder">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.reducePlaceHolder"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系方式" prop="contactDesc">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.contactDesc"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="输入内容框" prop="parseDesc">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.parseDesc"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="统计" prop="parseButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.parseButton"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="清除" prop="clearParseButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.clearParseButton"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="存储次数" prop="cacheTimeDesc">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.cacheTimeDesc"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="预估H扣库" prop="ygPl">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.ygPl"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="进货总计" prop="caculDesc">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.caculDesc"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="说明框" prop="dedc">
        <el-col :span="18">
          <el-input type="textarea" size="small" v-model="editForm.desc"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="进货总计" prop="caculDesc">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.caculDesc"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="切换科目" prop="changeClz">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.changeClz"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="增加科目" prop="addClz">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.addClz"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="切换客户" prop="changeCs">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.changeCs"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="设置客户" prop="addCs">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.addCs"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="C" prop="cv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.cv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="D" prop="dv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.dv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="显示总表" prop="displayTotal">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.displayTotal"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="U" prop="uv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.uv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="V" prop="vv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.vv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="W" prop="wv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.wv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="G" prop="gv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.gv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Z" prop="zv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.zv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="N" prop="nv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.nv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="M" prop="zv">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.mv"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="汇总选择编号" prop="hzChosen">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.hzChosen"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="汇总查看" prop="hzCheck">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.hzCheck"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="预估编号" prop="ygOrderId">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.ygOrderId"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="预估数量" prop="ygNumber">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.ygNumber"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="科目" prop="km">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.km"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="新增科目" prop="km">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.addkm"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="排序按钮" prop="sortButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.sortButton" placeholder="排序"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="复制按钮（主界面）" prop="copyLiveButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.copyLiveButton" placeholder="复制"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="风险按钮" prop="riskButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.riskButton" placeholder="风险"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="添加按钮" prop="addButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.addButton" placeholder="添加"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="设置最大亏损（提示）" prop="maxLossPlaceholder">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.maxLossPlaceholder" placeholder="设置最大亏损"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="添加编号框（提示）" prop="addOrderPlaceholder">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.addOrderPlaceholder" placeholder="编号"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="添加数量框提示" prop="addNumPlaceholder">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.addNumPlaceholder" placeholder="数量"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="对单按钮" prop="duidangButton">
        <el-col :span="8">
          <el-input size="small" v-model="editForm.duidangButton" placeholder="对单"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">提交修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapsList, mapsSave } from '../../api/mapsMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      editForm: {
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      mapsList()
        .then(res => {
          console.log(res);
          this.loading = false
          if (res.data.code != 0) {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          } else {
            this.editForm = res.data.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          console.log(JSON.stringify(this.editForm));
          mapsSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              console.log(res);
              if (res.data.code == 0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/maps/maps.vue